import React from "react";
import { FormattedMessage, useIntl } from "react-intl";
import PropTypes from "prop-types";
import classNames from "classnames";
import styles from "./Tip.scss";

import { Button, Image } from "@fluentui/react-components";

import {
  TeachingPopover,
  TeachingPopoverBody,
  TeachingPopoverHeader,
  TeachingPopoverTitle,
  TeachingPopoverSurface,
  TeachingPopoverTrigger,
  TeachingPopoverFooter
} from "@fluentui/react-components";

const inlinePopoverFooter = {
  paddingTop: "12px",
  display: "flex",
  justifyContent: "flex-end",
  gap: "8px"
};

const isMobile = AFRAME.utils.device.isMobile();

const teachingPopoverStyles = {
  maxWidth: "480px",
  margin: "auto",
  position: "fixed",
  bottom: isMobile ? "250px" : "110px",
  WebkitTransform: "translateX(-50%)",
  transform: "translateX(-50%)",
  left: "50%"
};

export function FluentTips({
  className,
  step,
  children,
  onDismiss,
  activeStep,
  dismissLabel,
  onSetTipSelected,
  buttonStart,
  activeButtonLabel,
  hideSkipButton,
  header,
  content,
  ...rest
}) {
  const intl = useIntl();

  return (
    <TeachingPopoverSurface style={teachingPopoverStyles}>
      {/* <TeachingPopoverHeader>Tips</TeachingPopoverHeader> */}
      <TeachingPopoverBody>
        <TeachingPopoverTitle>{header}</TeachingPopoverTitle>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "start", gap: "8px" }}>
          {content || children}
        </div>
      </TeachingPopoverBody>
      {/* <TeachingPopoverFooter 

          primary={ (props) => (
            
              <Button appearance="primary" onClick={hideSkipButton ? onDismiss : onSetTipSelected}>
                  {intl.formatMessage({
                    id: activeButtonLabel.id,
                    defaultMessage: activeButtonLabel.header
                  })}
              </Button> 
          )} 

          secondary={
          !hideSkipButton ?
            <Button appearance="secondary" onClick={onDismiss}>
              {dismissLabel}
            </Button>  
          : undefined } />  */}
      <div style={inlinePopoverFooter}>
        {buttonStart && (
          <Button appearance="primary" onClick={hideSkipButton ? onDismiss : onSetTipSelected}>
            {intl.formatMessage({
              id: activeButtonLabel?.id,
              defaultMessage: activeButtonLabel.header
            })}
          </Button>
        )}
        {!hideSkipButton && (
          <Button appearance="secondary" onClick={onDismiss}>
            {dismissLabel}
          </Button>
        )}
      </div>
    </TeachingPopoverSurface>
    // <div className={classNames(styles.tip, className)} {...rest}>
    //   <div className={styles.content}>{children}</div>
    //   {onDismiss && (
    //     <div className={styles.rightContainer}>
    //       {step && activeStep && (
    //         <div className={styles.steps}>
    //           <FormattedMessage
    //             id="tips.lobby-step"
    //             defaultMessage="{activeStep}/{steps}"
    //             values={{ steps: step.length - 2, activeStep }}
    //           />
    //         </div>
    //       )}

    //       <div className={styles.buttonsContainer}>
    //         {buttonStart && (
    //           <button
    //             className={classNames(styles.activeButton, styles.baseButton)}
    //             onClick={hideSkipButton ? onDismiss : onSetTipSelected}
    //           >
    //             {intl.formatMessage({
    //               id: activeButtonLabel.id,
    //               defaultMessage: activeButtonLabel.header
    //             })}
    //           </button>
    //         )}
    //         {!hideSkipButton && (
    //           <button className={classNames(styles.dismissButton, styles.baseButton)} onClick={onDismiss}>
    //             {dismissLabel}
    //           </button>
    //         )}
    //       </div>
    //     </div>
    //   )}
    // </div>
  );
}

FluentTips.propTypes = {
  className: PropTypes.string,
  step: PropTypes.array,
  onSetTipSelected: PropTypes.func,
  buttonStart: PropTypes.bool,
  hideSkipButton: PropTypes.bool,
  activeStep: PropTypes.number,
  activeButtonLabel: PropTypes.object,
  children: PropTypes.node,
  onDismiss: PropTypes.func,
  dismissLabel: PropTypes.node
};
